export default __webpack_public_path__ + "static/mstile-310x150-664f4c70587144a630b2e3405ed31ece.png";